import { useSubscription } from "@apollo/client";
import { isAuthenticated } from "@src/auth/auth-utils";
import {
	navbarBranchQueryKeys,
	navbarTreeQueryKeys,
} from "@src/components/board/queries/fetch-ranklist";
import { whiteboardQueryKeys } from "@src/components/board/queries/query-keys";
import { graphql } from "@src/gql";
import { NavbarSection } from "@src/gql/graphql";
import { useQueryClient } from "@tanstack/react-query";

const NAVBAR_TREE_SECTIONS = [
	NavbarSection.MyWhiteboards,
	NavbarSection.SharedWithMe,
	NavbarSection.Favourites,
] as const;

export const myWhiteboardsProjectedSubscription = graphql(/* GraphQL */ `
	subscription myWhiteboardsProjectedSubscription($whiteboardId: String, $correlationId: String, $shareKey: String) {
		myWhiteboardsProjected(whiteboardId: $whiteboardId, correlationId: $correlationId, shareKey: $shareKey) {
			entityId
			isSuccess
			projectedTime
			sequence
			subscriptionName
			event {
				causationId
				correlationId
				id
				number
				eventType
			}
		}
	}
`);

/**
 * Custom hook to subscribe to whiteboard projection updates.
 * Invalidates whiteboard and navbar queries on successful updates.
 */
export function useMyWhiteboardsProjectedSubscription() {
	const queryClient = useQueryClient();

	useSubscription(myWhiteboardsProjectedSubscription, {
		skip: !isAuthenticated(),
		variables: {
			whiteboardId: null,
			correlationId: null,
			shareKey: null,
		},
		onData: (change) => {
			// Ensure data and nested properties exist before accessing isSuccess
			if (change.data?.data?.myWhiteboardsProjected?.isSuccess === true) {
				queryClient.invalidateQueries({
					queryKey: whiteboardQueryKeys.active(),
				});

				queryClient.invalidateQueries({
					queryKey: whiteboardQueryKeys.owned(),
				});

				queryClient.invalidateQueries({
					queryKey: whiteboardQueryKeys.shared(),
				});

				queryClient.invalidateQueries({
					queryKey: navbarBranchQueryKeys.all(),
				});
				for (const section of NAVBAR_TREE_SECTIONS) {
					queryClient.invalidateQueries({
						queryKey: navbarTreeQueryKeys.tree(section),
					});
				}
			}
		},
	});
}
